module.exports = __webpack_public_path__ + "img/5-3.c6c01dac.png";